import type { MouseEvent } from "react";

import { ChevronDownIcon } from "lucide-react";

import { cx, styled } from "simplydo/react/styled";

import { asIcon } from "../icon";
import { AccordionTitleIcon, StyledAccordionTitle } from "./Accordion.styles";
import type { AccordionTitleProps } from "./Accordion.types";
import { useAccordionContext } from "./AccordionContext";

const AccordionTitleComponent = (props: AccordionTitleProps) => {
  const {
    active: activeProp,
    children,
    className,
    icon,
    index,
    tabIndex,
    onKeyDown,
    style,
    onClick,
  } = props;

  const ctx = useAccordionContext();
  const active =
    activeProp !== undefined
      ? activeProp
      : (ctx?.isIndexActive(index) ?? false);

  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    const data: AccordionTitleProps = { ...props, active };
    onClick?.(event, data);
    ctx?.handleTitleClick(event, data);
  };

  const classes = cx(active && "is-active", className);
  const resolvedIcon =
    icon === false ? null : asIcon(icon || ChevronDownIcon, AccordionTitleIcon);

  return (
    <StyledAccordionTitle
      className={cx(classes)}
      style={style}
      tabIndex={tabIndex}
      onKeyDown={onKeyDown}
      onClick={handleClick}
    >
      {resolvedIcon}
      {children}
    </StyledAccordionTitle>
  );
};

export const AccordionTitle = styled(AccordionTitleComponent)``;
